import { assertUnreachable } from '@sgme/fp';

import type { PredealCheck, QuotePredealCheck } from '@/types/common.ts';

export function toPredealCheck(check: QuotePredealCheck): PredealCheck {
  switch (check.Type) {
    case 'Icon':
      return {
        type: check.Type,
        label: check.Label,
        statusHealth: check.StatusHealth,
      };

    case 'Label':
      return {
        type: check.Type,
        label: check.Label,
        statusHealth: check.StatusHealth,
        statusValue: check.StatusValue ?? '',
      };

    default:
      return assertUnreachable(check, `Unknown predeal check ${check}`);
  }
}
